//Core
import React, {Fragment, Suspense, useState} from 'react';

//External
import { Col, Row} from "react-bootstrap";

//Internal
import {showToast, getSessionValue, getAppType} from "../../../Common/Appcommon";
import ListBox from "../../../Common/ListBox";
import {IntegrationListItems,IntegrationListSearchItems} from "../../Analytics/Constants";
import WebsiteChat from "./IntegrationWidgets/WebsiteChat";
import LinkGenerator from "./IntegrationWidgets/LinkGenerator";
import FaceBook from "../FaceBook";
import EmailParser from "../EmailParser";
import LegacyApiKey from "../LegacySettings/LegacyApiKey";
import LegacyIndiamart from "../LegacySettings/LegacyIndiamart";
import GoogleAds from "../GoogleAds";
import WebhooksIntegration from '../Webhooks';
import pabblyIntegration from '../LegacySettings/Pabbly';
import Select from "react-select";

const components = {
    'website_chat': WebsiteChat,
    'link_generator' : LinkGenerator,
    'facebook_mapping' : FaceBook,
    'googleads' : GoogleAds,
    'indiamart' : LegacyIndiamart,
    'email_parser' : EmailParser,
    'api_key' : LegacyApiKey,
    'webhooks' : WebhooksIntegration,
    'pabbly' : pabblyIntegration,
}
let CurrentComponent = "";

const IntegrationItems = props => {

    const [isConfigView, setIsConfigView] = useState(props.selectedTab !== "" && components[props.selectedTab] !== undefined ? true : false);
    const [componentName, setConfigComponentName] = useState(props.selectedTab !== "" && components[props.selectedTab] !== undefined ? props.selectedTab : "");
	const [selectedintegrationSearchOption, setintegrationSearchOption] = useState(IntegrationListSearchItems[0]);

    if(props.selectedTab !== "" && components[props.selectedTab] !== undefined){
        CurrentComponent = components[props.selectedTab];
    }

    let isadmin = getSessionValue('isadmin') === 'Yes' ? true : false;

    const onExploreAction = async (e, crname, url = "") => {
        if(components[crname] !== undefined){
            setIsConfigView(true);
            setConfigComponentName(crname);
            CurrentComponent = components[crname]
        } else {
            if(url != ""){
                window.open(url, "_target");
            }else{
                showToast("Coming Soon...!", "top-right","success");
            }
        }
    }

    const onBackAction = async(e) => {
        setIsConfigView(false);
        setConfigComponentName("");
        CurrentComponent = "";
        window.location = "#/settings/integrations";
    }

    const handleChange = async(option) =>{
        setintegrationSearchOption(option);
    }

    let integrationItems = IntegrationListItems;

    let appType = getAppType();
    appType = parseInt(appType);
    return (
        <>
            <Fragment>
                <div className={'header-d-flex-integration col-md-6 w-270'}>
                    {
                        <Select
                            isClearable={false}
                            onChange={(eve) => {
                                handleChange(eve)
                            }}
                            placeholder={"A"}
                            options={IntegrationListSearchItems}
                            value={selectedintegrationSearchOption}
                            className="basic-multi-select col-md-12 mR10"
                            classNamePrefix="le-select"
                        />
                    }
                </div>
                <div className={'setup-integration'}>                   
                    <div className={"col-md-12 integration-container"}>
                        {!isConfigView ?
                            <Row>
                                {
                                    integrationItems != undefined &&
                                    integrationItems.map((integration)=>{
                                        if((integration.appType === 0 || integration.appType === appType) && ((integration.isAdminOnly && isadmin) || !integration.isAdminOnly) && (selectedintegrationSearchOption.value.includes(integration.crname) || selectedintegrationSearchOption.value == "all_items")){
                                            return (
                                                <ListBox onExploreAction={onExploreAction} ListData={integration}/>
                                            );
                                        }
                                    })
                                }
                            </Row>
                            :
                            <>
                                <CurrentComponent onBackAction={onBackAction} ctName={componentName} />
                            </>
                        }
                    </div>
                </div>
            </Fragment>
        </>
    )
}

export default IntegrationItems;
